import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FdaComponent } from './fda.component';

const routes: Routes = [
  {
    path: '',
    component: FdaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FdaRoutingModule {}
